import { render, staticRenderFns } from "./MergeFieldDropdown.vue?vue&type=template&id=79c87a9e&"
import script from "./MergeFieldDropdown.vue?vue&type=script&lang=js&"
export * from "./MergeFieldDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MergeFieldDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports